import React, { useEffect, useState } from "react";
import { DialogActions, InputAdornment } from "@material-ui/core";
import Swal from "sweetalert2";
import * as yup from "yup";
import { Card } from "react-bootstrap";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Table } from "react-bootstrap";
import { FieldArray, Formik } from "formik";
import { formatDate, setObject } from "../../../../../utils/utils";
import DialogLayout from "../../../../../partials/content/DialogLayout";
import { onPreventEnterSubmitting } from "../../../../../utils/utils";
import {
  CustomArraySelectField,
  CustomOutlinedDisabledTextField,
  CustomOutlinedDisabledNoMarginTextField,
} from "../../../../../partials/content/Forms";
import {
  FormArrayTextField,
  FormOutlinedNoMarginTextField,
} from "../../../../../partials/content/Forms/FormField";
import { getSalesOrderItems } from "../../../../../services/sales/salesOrderService";
import SearchItemStocksLocation from "../../items/searchItemStocksLocation";
import {
  getItemsReservation,
  saveDirectPickReservation,
} from "../../../../../services/inventory/itemReservationService";
import SearchSalesOrder from "../../../sales/salesOrder/searchSalesOrder";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";
import { useGlobalData } from "../../../../../../provider/GlobalDataProvider";
import store from "../../../../../store/store";
import { DateTime } from "luxon";
function DirectPickForm({
  itemRequestID = 0,
  salesOrder = {
    ID: 0,
    salesOrderCode: "",
    customerID: 0,
    customer: { customerName: "" },
    expDeliveryDate: DateTime.now().endOf("day"),
  },
  deliveryOrder = {},
  warehouseID = 0,
  itemID = 0,
  varCode = "",
  uomID = 0,
  onCloseDialog,
  onConfirmSave,
}) {
  const { socket, reload } = useGlobalData();
  const { auth } = store.getState();
  const userID = auth.user.userID;
  const [itemReservation, setItemReservation] = useState({
    salesOrderCode: salesOrder.salesOrderCode,
    salesOrderID: salesOrder.ID,
    customerID: salesOrder.customerID,
    warehouseID,
    expDeliveryDate: salesOrder.expDeliveryDate,
    customerName: salesOrder.customer.customerName,
    itemsReservation: [],
  });
  const [deliveries, setDeliveries] = useState([]);
  const [soItemOptions, setSoItemOptions] = useState([]);
  const [openSearchStock, setOpenSearchStock] = useState(false);
  const [openSearchSalesOrder, setOpenSearchSalesOrder] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [activeIndex, setActiveIndex] = useState(0);
  const itemsReservationSchema = yup.object().shape({
    itemsReservation: yup
      .array()
      .of(
        yup.object().shape({
          ID: yup.number(),
          processReserve: yup.bool(),
          soItem: yup.object().shape({
            ID: yup.number(),
          }),
          warehouseID: yup.number(),
          outletID: yup.number(),
          itemID: yup.number(),
          varCode: yup.string(),
          qty: yup.number().when("processReserve", {
            is: (val) => val,
            then: yup
              .number()
              .min(1, "Quantity cannot be zero or empty")
              .required("Quantity cannot be empty")
              .max(
                yup.ref("orderQty"),
                "Quantity cannot be more than Ordered Quantity"
              )
              .max(
                yup.ref("stockQty"),
                "Quantity cannot be more than Stock Quantity"
              ),
          }),
          orderQty: yup.number(),
          stockQty: yup.number(),
          batchID: yup.number().when("processReserve", {
            is: (val) => val,
            then: yup
              .number()
              .min(1, "Batch ID is required")
              .required("Batch ID is required"),
          }),
          uomID: yup.number(),
          uomName: yup.string(),
        })
      )
      .required("Process Items are required"),
  });
  const [selectedItem, setSelectedItem] = useState({
    itemID: 0,
    varCode: "",
    uomID: 0,
  });

  useEffect(() => {
    if (salesOrder.ID > 0) {
      setObject(socket, "lock", salesOrder.ID, "SORD", auth.user).then(
        (response) => {
          getSalesOrderItemData(salesOrder);
        }
      );
    }
    if (itemID > 0) {
      setSelectedItem({
        itemID,
        varCode,
        uomID,
      });
    }
    return () => {
      if (salesOrder.ID > 0) {
        setObject(socket, "release", salesOrder.ID, "SORD", auth.user);
      }
    };
  }, [salesOrder.ID, itemID, varCode, uomID, reload]);
  return (
    <Formik
      initialValues={itemReservation}
      enableReinitialize={true}
      validateOnChange={false}
      validationSchema={itemsReservationSchema}
      onSubmit={async (values, { resetForm, setStatus, setSubmitting }) => {
        for (const itemReserve of values.itemsReservation) {
          itemReserve.qty = parseFloat(itemReserve.qty);
        }
        Swal.mixin({
          customClass: {
            confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
          },
          buttonsStyling: false,
        })
          .fire({
            title: "Are you sure want to save this Items Reservation ?",
            text: "Please note that you are responsible for this action",
            icon: "question",
            showCloseButton: true,
            showCancelButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, save it`,
            cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
            reverseButtons: true,
          })
          .then((result) => {
            if (result.isConfirmed) {
              saveDirectPickReservation(values.itemsReservation).then(
                (response) => {
                  Swal.mixin({
                    customClass: {
                      confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                    },
                    buttonsStyling: false,
                  }).fire({
                    title: "Saved",
                    html: response.data.message,
                    icon: "success",
                    showCloseButton: true,
                    confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                  });
                  if (onConfirmSave) {
                    onConfirmSave();
                  } else {
                    resetForm();
                  }
                }
              );
            } else if (result.dismiss === Swal.DismissReason.cancel) {
              Swal.mixin({
                customClass: {
                  confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                },
                buttonsStyling: false,
              }).fire({
                title: "Cancelled",
                text: "No change has been made",
                icon: "info",
                showCloseButton: true,
                confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
              });
            }
          });
      }}
    >
      {({
        values,
        status,
        errors,
        touched,
        dirty,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        isSubmitting,
      }) => (
        <form
          noValidate={true}
          autoComplete="off"
          className="kt-form"
          onSubmit={handleSubmit}
          onKeyDown={onPreventEnterSubmitting}
        >
          <div className="row mb-3">
            <div className="col-sm-12 col-md-12 col-lg-12">
              <Card>
                <Card.Header>
                  <i className="fas fa-window-maximize"></i>
                  <span>
                    <strong>Sales Order Header</strong>
                  </span>
                </Card.Header>
                <Card.Body>
                  <div className="row">
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <CustomOutlinedDisabledTextField
                        label="Sales Order ID"
                        value={salesOrder.salesOrderCode}
                      />
                      <CustomOutlinedDisabledTextField
                        label="Customer"
                        value={salesOrder.customer.customerName}
                      />
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <CustomOutlinedDisabledTextField
                        label="Order Date"
                        value={formatDate(salesOrder.orderDate)}
                      />
                      <CustomOutlinedDisabledTextField
                        label="Expected Delivery Date"
                        value={formatDate(salesOrder.expDeliveryDate)}
                      />
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </div>
          </div>
          <div className="accordion">
            <div className="card">
              <Accordion
                className="accordion"
                activeIndex={activeIndex}
                onTabChange={(e) => setActiveIndex(e.index)}
              >
                <AccordionTab
                  header={
                    <React.Fragment>
                      <i className="fas fa-sitemap"></i>
                      <span>
                        <strong>Process Sales Order Items</strong>
                      </span>
                    </React.Fragment>
                  }
                >
                  <div className="row">
                    <div className="col-sm-12 col-md-12 col-lg-12">
                      <FieldArray name="itemsReservation">
                        {({ push, remove }) => (
                          <React.Fragment>
                            <div className="card">
                              <Table borderless size="sm" responsive="xl">
                                {values.itemsReservation &&
                                values.itemsReservation.length > 0 ? (
                                  <thead className="text-center">
                                    <tr>
                                      <th style={{ width: "45%" }}>
                                        Process Item
                                      </th>
                                      <th style={{ width: "10%" }}>Batch ID</th>
                                      <th style={{ width: "10%" }}>Quantity</th>
                                      <th style={{ width: "10%" }}>
                                        Ordered Quantity
                                      </th>
                                      <th style={{ width: "10%" }}>
                                        Stock Quantity
                                      </th>
                                      <th style={{ width: "15%" }}>Unit</th>
                                      <th>Action</th>
                                    </tr>
                                  </thead>
                                ) : null}
                                <tbody>
                                  {values.itemsReservation &&
                                  values.itemsReservation.length > 0
                                    ? values.itemsReservation.map(
                                        (item, index) => (
                                          <tr key={index}>
                                            <td>
                                              {item.ID === 0 ? (
                                                <CustomArraySelectField
                                                  arrayName="itemsReservation"
                                                  propertyName="soItem"
                                                  onBlur={handleBlur}
                                                  onChange={(e) => {
                                                    const selectedSoItem = {
                                                      ...e.target.value,
                                                    };
                                                    setFieldValue(
                                                      `itemsReservation[${index}]`,
                                                      {
                                                        ID: 0,
                                                        processReserve: true,
                                                        soItem: { ID: 0 },
                                                        itemRequestID,
                                                        warehouseID,
                                                        warehouseName: "",
                                                        outletID: 0,
                                                        outletName: "",
                                                        customerID:
                                                          salesOrder.customerID,
                                                        salesOrderID:
                                                          salesOrder.ID,
                                                        salesOrderItemID:
                                                          selectedSoItem.ID,
                                                        salesPosID: 0,
                                                        salesPosItemID: 0,
                                                        deliveryID: 0,
                                                        itemID:
                                                          selectedSoItem.itemID,
                                                        itemType:
                                                          selectedSoItem.itemType,
                                                        itemTypeName:
                                                          selectedSoItem.itemTypeName,
                                                        itemCode:
                                                          selectedSoItem.itemCode,
                                                        itemName:
                                                          selectedSoItem.itemName,
                                                        location: "",
                                                        varCode:
                                                          selectedSoItem.varCode,
                                                        qty: 0,
                                                        orderQty:
                                                          selectedSoItem.qty,
                                                        stockQty: 0,
                                                        batchID: 0,
                                                        uomID:
                                                          selectedSoItem.uomID,
                                                        uomName:
                                                          selectedSoItem.uomName,
                                                        deleteInd: false,
                                                      }
                                                    );
                                                    handleChange(e);
                                                  }}
                                                  index={index}
                                                  value={values}
                                                  touched={touched}
                                                  errors={errors}
                                                  options={soItemOptions}
                                                />
                                              ) : (
                                                <FormOutlinedNoMarginTextField
                                                  value={`${item.itemCode} ${item.itemName}`}
                                                  InputProps={{
                                                    startAdornment:
                                                      item.itemType > 0 ? (
                                                        <InputAdornment position="start">
                                                          <BootstrapTooltip
                                                            title={
                                                              item.itemTypeName
                                                            }
                                                          >
                                                            <i
                                                              className={
                                                                item.itemType ===
                                                                1
                                                                  ? "fas fa-boxes text-success"
                                                                  : item.itemType ===
                                                                    2
                                                                  ? "fas fa-tools text-primary"
                                                                  : item.itemType ===
                                                                    3
                                                                  ? "fas fa-building text-info"
                                                                  : item.itemType ===
                                                                    4
                                                                  ? "fas fa-boxes text-warning"
                                                                  : item.itemType ===
                                                                    5
                                                                  ? "fas fa-boxes text-danger"
                                                                  : null
                                                              }
                                                            ></i>
                                                          </BootstrapTooltip>
                                                        </InputAdornment>
                                                      ) : null,
                                                    readOnly: true,
                                                  }}
                                                />
                                              )}
                                            </td>
                                            <td>
                                              <FormArrayTextField
                                                arrayPropName="itemsReservation"
                                                index={index}
                                                propName="batchID"
                                                searchButton={
                                                  item.ID === 0 ? true : false
                                                }
                                                margin="none"
                                                readonly
                                                onSearchClick={() => {
                                                  setSelectedItem({
                                                    itemID: item.itemID,
                                                    varCode: item.varCode,
                                                    uomID: item.uomID,
                                                  });
                                                  setSelectedIndex(index);
                                                  setOpenSearchStock(true);
                                                }}
                                              />
                                            </td>
                                            <td>
                                              <FormArrayTextField
                                                arrayPropName="itemsReservation"
                                                index={index}
                                                propName="qty"
                                                quantityField
                                                margin="none"
                                                readonly={
                                                  item.ID > 0 ? true : false
                                                }
                                              />
                                            </td>
                                            <td>
                                              <FormArrayTextField
                                                arrayPropName="itemsReservation"
                                                index={index}
                                                propName="orderQty"
                                                quantityField
                                                margin="none"
                                                readonly
                                              />
                                            </td>
                                            <td>
                                              <FormArrayTextField
                                                arrayPropName="itemsReservation"
                                                index={index}
                                                propName="stockQty"
                                                quantityField
                                                margin="none"
                                                readonly
                                              />
                                            </td>
                                            <td>
                                              <FormArrayTextField
                                                arrayPropName="itemsReservation"
                                                index={index}
                                                propName="uomName"
                                                margin="none"
                                                readonly
                                              />
                                            </td>
                                            <td
                                              style={{ whiteSpace: "nowrap" }}
                                              className="text-center"
                                            >
                                              {item.ID === 0 && index > 0 ? (
                                                <BootstrapTooltip title="Delete Sales Order Item">
                                                  <button
                                                    type="button"
                                                    className={`btn btn-icon btn-label-danger btn-md btn-circle mx-1`}
                                                    onClick={() => {
                                                      remove(index);
                                                    }}
                                                  >
                                                    <i className="fas fa-trash-alt"></i>
                                                  </button>
                                                </BootstrapTooltip>
                                              ) : null}
                                            </td>
                                          </tr>
                                        )
                                      )
                                    : null}
                                  {deliveries && deliveries.length > 0
                                    ? deliveries.map((item, index) => (
                                        <tr key={index}>
                                          <td>
                                            <FormOutlinedNoMarginTextField
                                              value={`${item.itemCode} ${item.itemName}`}
                                              InputProps={{
                                                startAdornment:
                                                  item.itemType > 0 ? (
                                                    <InputAdornment position="start">
                                                      <BootstrapTooltip
                                                        title={
                                                          item.itemTypeName
                                                        }
                                                      >
                                                        <i
                                                          className={
                                                            item.itemType === 1
                                                              ? "fas fa-boxes text-success"
                                                              : item.itemType ===
                                                                2
                                                              ? "fas fa-tools text-primary"
                                                              : item.itemType ===
                                                                3
                                                              ? "fas fa-building text-info"
                                                              : item.itemType ===
                                                                4
                                                              ? "fas fa-boxes text-warning"
                                                              : item.itemType ===
                                                                5
                                                              ? "fas fa-boxes text-danger"
                                                              : null
                                                          }
                                                        ></i>
                                                      </BootstrapTooltip>
                                                    </InputAdornment>
                                                  ) : null,
                                                readOnly: true,
                                              }}
                                            />
                                          </td>
                                          <td>
                                            <CustomOutlinedDisabledNoMarginTextField
                                              value={item.batchID}
                                            />
                                          </td>
                                          <td>
                                            <CustomOutlinedDisabledNoMarginTextField
                                              value={item.qty}
                                            />
                                          </td>
                                          <td>
                                            <CustomOutlinedDisabledNoMarginTextField
                                              value={0}
                                            />
                                          </td>
                                          <td>
                                            <CustomOutlinedDisabledNoMarginTextField
                                              value={0}
                                            />
                                          </td>
                                          <td>
                                            <CustomOutlinedDisabledNoMarginTextField
                                              value={item.uom.uomName}
                                            />
                                          </td>
                                          <td>
                                            <BootstrapTooltip title="Delivered">
                                              <button
                                                type="button"
                                                className={`btn btn-icon btn-label-warning btn-md btn-circle mx-1`}
                                                onClick={() => {}}
                                              >
                                                <i className="fas fa-truck"></i>
                                              </button>
                                            </BootstrapTooltip>
                                          </td>
                                        </tr>
                                      ))
                                    : null}
                                  <tr>
                                    <td
                                      className="text-center py-3"
                                      colSpan="7"
                                    >
                                      <button
                                        type="button"
                                        className="btn btn-label-primary btn-md btn-pill btn-bold mx-1"
                                        onClick={() => {
                                          push({
                                            ID: 0,
                                            processReserve: true,
                                            soItem: { ID: 0 },
                                            itemRequestID,
                                            warehouseID,
                                            warehouseName: "",
                                            outletID: 0,
                                            outletName: "",
                                            customerID: salesOrder.customerID,
                                            salesOrderID: salesOrder.ID,
                                            salesOrderItemID: 0,
                                            salesPosID: 0,
                                            salesPosItemID: 0,
                                            deliveryID: 0,
                                            itemID: 0,
                                            itemType: 0,
                                            itemTypeName: "",
                                            itemCode: "",
                                            itemName: "",
                                            location: "",
                                            varCode: "",
                                            qty: 0,
                                            orderQty: 0,
                                            stockQty: 0,
                                            batchID: 0,
                                            uomID: 0,
                                            uomName: "",
                                            deleteInd: false,
                                          });
                                        }}
                                      >
                                        <i className="fas fa-plus-circle"></i>
                                        Add Sales Order Item
                                      </button>
                                    </td>
                                  </tr>
                                </tbody>
                              </Table>
                            </div>
                          </React.Fragment>
                        )}
                      </FieldArray>
                    </div>
                  </div>
                </AccordionTab>
              </Accordion>
            </div>
          </div>
          <DialogActions>
            <button
              type="button"
              className="btn btn-label-danger btn-md btn-pill btn-bold"
              onClick={onCloseDialog}
            >
              <i className="fas fa-window-close"></i>
              Close
            </button>
            <button
              type="submit"
              className="btn btn-success btn-md btn-pill btn-bold"
            >
              <i className="fas fa-save"></i>
              Save
            </button>
          </DialogActions>
          <DialogLayout
            open={openSearchSalesOrder}
            title="Search Sales Order"
            onCloseDialog={() => {
              setOpenSearchSalesOrder(false);
            }}
            fullScreen={false}
          >
            <SearchSalesOrder
              giStatus="0"
              reserveStatus="12"
              showAmount={false}
              onSelectSalesOrder={async (salesOrder) => {
                setFieldValue("salesOrderID", salesOrder.ID);
                setFieldValue("customerID", salesOrder.customerID);
                setFieldValue("customerName", salesOrder.customer.customerName);
                setFieldValue(
                  "expDeliveryDate",
                  formatDate(salesOrder.expDeliveryDate)
                );
                setFieldValue("itemsReservation", []);
                getSalesOrderItemData(salesOrder.ID, setFieldValue);
                setOpenSearchSalesOrder(false);
              }}
            />
            <DialogActions>
              <button
                type="button"
                className="btn btn-label-danger btn-md btn-pill btn-bold"
                onClick={() => {
                  setOpenSearchSalesOrder(false);
                }}
              >
                <i className="fas fa-window-close"></i>
                Close
              </button>
            </DialogActions>
          </DialogLayout>
          <DialogLayout
            open={openSearchStock}
            title="Search Stock"
            onCloseDialog={() => {
              setOpenSearchStock(false);
            }}
            fullScreen={false}
          >
            <SearchItemStocksLocation
              itemID={selectedItem.itemID}
              varCode={selectedItem.varCode}
              uomID={selectedItem.uomID}
              warehouseID={warehouseID}
              onSelectLocation={(location) => {
                let itemFound = false;
                for (const itemReserve of values.itemsReservation) {
                  if (
                    itemReserve.processReserve &&
                    itemReserve.warehouseID === location.locationID &&
                    itemReserve.batchID === location.batchID
                  ) {
                    itemFound = true;
                  }
                }
                if (!itemFound) {
                  setFieldValue(
                    `itemsReservation[${selectedIndex}].warehouseID`,
                    location.locationID
                  );
                  setFieldValue(
                    `itemsReservation[${selectedIndex}].warehouseName`,
                    location.locationName
                  );
                  setFieldValue(
                    `itemsReservation[${selectedIndex}].stockQty`,
                    location.qty
                  );
                  setFieldValue(
                    `itemsReservation[${selectedIndex}].batchID`,
                    location.batchID
                  );
                  setOpenSearchStock(false);
                } else {
                  Swal.mixin({
                    customClass: {
                      confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                    },
                    buttonsStyling: false,
                  }).fire({
                    title: "Failed",
                    text: "Item Batch already selected",
                    icon: "error",
                    showCloseButton: true,
                    confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                  });
                }
              }}
            />
            <DialogActions>
              <button
                type="button"
                className="btn btn-label-danger btn-md btn-pill btn-bold"
                onClick={() => {
                  setOpenSearchStock(false);
                }}
              >
                <i className="fas fa-window-close"></i>
                Close
              </button>
            </DialogActions>
          </DialogLayout>
        </form>
      )}
    </Formik>
  );

  async function getSalesOrderItemData(
    salesOrder = {
      ID: 0,
      customerID: 0,
      expDeliveryDate: DateTime.now().endOf("day"),
      customer: { customerName: "" },
    }
  ) {
    const itemReservationTmp = { ...itemReservation };
    const itemsReservation = [];
    const soItemOptions = [];

    const responseReserve = await getItemsReservation(
      salesOrder.ID,
      0,
      0,
      warehouseID,
      0,
      "-"
    );
    const { data: dataReserve } = responseReserve.data;
    for (const itemReserve of dataReserve.itemsReservation) {
      itemsReservation.push({
        ID: itemReserve.ID,
        processReserve: false,
        itemRequestID,
        warehouseID: itemReserve.warehouseID,
        warehouseName: "",
        outletID: 0,
        outletName: "",
        customerID: itemReserve.customerID,
        salesOrderID: itemReserve.salesOrderID,
        salesOrderItemID: itemReserve.salesOrderItemID,
        salesPosID: 0,
        salesPosItemID: 0,
        deliveryID: 0,
        itemID: itemReserve.itemID,
        itemType: itemReserve.itemType,
        itemTypeName: itemReserve.itemTypeName,
        itemCode: itemReserve.itemCode,
        itemName: itemReserve.itemName,
        location: "",
        varCode: itemReserve.varCode,
        qty: itemReserve.qty,
        orderQty: 0,
        stockQty: 0,
        batchID: itemReserve.batchID,
        uomID: itemReserve.uomID,
        uomName: itemReserve.uomName,
        deleteInd: false,
      });
    }
    setDeliveries(dataReserve.deliveryItems);

    const response = await getSalesOrderItems(salesOrder.ID);
    const { data } = response.data;
    for (const soItem of data.salesOrderItems) {
      soItemOptions.push({
        label: soItem.itemName,
        value: soItem,
      });

      for (const itemReserve of itemsReservation) {
        if (itemReserve.salesOrderItemID === soItem.ID) {
          itemReserve.orderQty = soItem.qty;
          break;
        }
      }
    }
    itemReservationTmp.itemsReservation = itemsReservation;
    setItemReservation(itemReservationTmp);
    setSoItemOptions(soItemOptions);
  }
}

export default DirectPickForm;
